<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">Lead</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  @if (lead) {
    <div>
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between">
        <h3 class="fw-bold fs-6 mb-0">General</h3>
      </div>
      <table class="table">
        <tbody>
          <tr>
            <th>ID</th>
            <td>{{ lead.id }}</td>
          </tr>
          <tr>
            <th>Unique Reference</th>
            <td>{{ lead.uniqueReference }}</td>
          </tr>
          <tr>
            <th>
              Created at
            </th>
            <td>
              {{ lead.createdAt | parisDate }}
            </td>
          </tr>
          <tr>
            <th>
              CID
            </th>
            <td>
              {{ lead.cid }}
            </td>
          </tr>
          <tr>
            <th>
              Site
            </th>
            <td>
              {{ lead.site }}
            </td>
          </tr>
          <tr>
            <th>Brand</th>
            <td>{{ lead.product }}</td>
          </tr>
          <tr>
            <th>Offer</th>
            <td>{{ lead.offer }}</td>
          </tr>
          <tr>
            <th>Partner</th>
            <td>{{ lead.partner }}</td>
          </tr>
          <tr>
            <th>Promotion link</th>
            <td>{{ lead.landingPage }}</td>
          </tr>
          <tr>
            <th>
              Typology
            </th>
            <td>
              {{ lead.sourceTypology }}
            </td>
          </tr>
          <tr>
            <th>
              P2
            </th>
            <td>
              {{ lead.coreg }}
            </td>
          </tr>
          <tr>
            <th>
              XSELL
            </th>
            <td>
              {{ lead.cross }}
            </td>
          </tr>
          <tr>
            <th>
              Source Type
            </th>
            <td>
              {{ lead.sourceType }}
            </td>
          </tr>
          <tr>
            <th>
              Source Details
            </th>
            <td>
              <pre>{{ getSourceDetails(lead) }}</pre>
            </td>
          </tr>
          @if (hasFingerprint(lead)) {
            <tr *isGranted="['ROLE_API_FINGERPRINT_VIEW']">
              <th>
                Fingerprint
              </th>
              <td>
                <pre>{{ getFingerprint(lead) }}</pre>
              </td>
            </tr>
          }
          <tr>
            <th>
              Wish
            </th>
            <td>
              {{ lead.wish }}
            </td>
          </tr>
          <tr>
            <th>Result</th>
            <td>
              <span [innerHTML]="leadService.getHtmlStatusIcon(lead)"></span> <span
            class="fw-bold">{{ leadService.getHtmlStatus(lead) }}</span>
          </td>
        </tr>
        <tr>
          <th>Succeeded</th>
          <td>{{ lead.succeeded ? '✅' : '❌' }}</td>
        </tr>
        <tr>
          <th>Double Optin</th>
          <td>{{ lead.doi ? '✅' : '❌' }}</td>
        </tr>
        <tr>
          <th>Bot</th>
          <td>{{ lead.bot ? '✅' : '❌' }}</td>
        </tr>
        <tr>
          <th>Already registered</th>
          <td>{{ lead.alreadyRegistered ? '✅' : '❌' }}</td>
        </tr>
        <tr>
          <th>Reactivated</th>
          <td>{{ lead.reactivated ? '✅' : '❌' }}</td>
        </tr>
        <tr>
          <th>Consent</th>
          <td>{{ lead.consent ? '✅' : '❌' }}</td>
        </tr>
          <tr>
            <th>Skip AR</th>
            <td>{{ lead.skipAr ? '✅' : '❌' }}</td>
          </tr>
        <tr>
          <th>Cost</th>
          <td>{{ lead.cost | money }}</td>
        </tr>
      </tbody>
    </table>
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
      <h3 class="fw-bold fs-6 mb-0">LeadUp</h3>
    </div>
    <table class="table">
      <tbody>
        <tr>
          <th>Response</th>
          <td>
            <pre>{{ getLeadUpResponse(lead) }}</pre>
          </td>
        </tr>
        <tr>
          <th>Status Code</th>
          <td>{{ lead.leadUpStatusCode }}</td>
        </tr>
        <tr>
          <th>Response time</th>
          <td>{{ lead.leadUpTime }}</td>
        </tr>
      </tbody>
    </table>
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
      <h3 class="fw-bold fs-6 mb-0">Technical</h3>
    </div>
    <table class="table">
      <tbody>
        <tr>
          <th>IP</th>
          <td>{{ lead.ip }}</td>
        </tr>
      </tbody>
    </table>
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
      <h3 class="fw-bold fs-6 mb-0">Customer</h3>
    </div>
    <table class="table">
      <tbody>
        <tr>
          <th>Firstname</th>
          <td>{{ lead.firstname }}</td>
        </tr>
        <tr>
          <th>Language</th>
          <td>{{ lead.language }}</td>
        </tr>
        <tr>
          <th>Country</th>
          <td>
            @if (lead.country) {
              <img [ngSrc]="countryService.getFlag(lead.country)"
                [alt]="lead.country" width="24" height="24" class="me-1">
            }
          </td>
        </tr>
        <tr>
          <th>E-mail</th>
          <td>{{ lead.email }}</td>
        </tr>
        <tr>
          <th>Gender</th>
          <td>{{ lead.gender }}</td>
        </tr>
        <tr>
          <th>Birthdate</th>
          <td>{{ lead.birthdate }}</td>
        </tr>
        <tr>
          <th>Birthplace</th>
          <td>{{ lead.birthPlace }}</td>
        </tr>
        <tr>
          <th>Birthplace ID (Google Maps)</th>
          <td>{{ lead.birthPlaceId }}</td>
        </tr>
      </tbody>
    </table>
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
      <h3 class="fw-bold fs-6 mb-0">Tracking</h3>
    </div>
    <table class="table">
      <tbody>
        <tr>
          <th>Sub ID</th>
          <td>{{ lead.subid }}</td>
        </tr>
        <tr>
          <th>TC1</th>
          <td>{{ lead.tc1 }}</td>
        </tr>
        <tr>
          <th>TC2</th>
          <td>{{ lead.tc2 }}</td>
        </tr>
        <tr>
          <th>TC3</th>
          <td>{{ lead.tc3 }}</td>
        </tr>
        <tr>
          <th>TC4</th>
          <td>{{ lead.tc4 }}</td>
        </tr>
        <tr>
          <th>Click ID</th>
          <td>{{ lead.clickid }}</td>
        </tr>
      </tbody>
    </table>
  </div>
}
</div>
